<template>
  <div class="table-container">
    <div class="scrollTop" @click="scrollToTop" v-show="showtop">
      <img src="../../assets/images/top-sub.png" />
    </div>
    <div class="left" v-if="loadingAll || leftData.length > 0">
      <subject-list-skeleton v-if="loadingAll && leftData.length === 0" variant="filter" />
      <left-menu v-else :leftData="leftData" @childByValue="childByValue" :scope="true"></left-menu>
    </div>
    <!-- 右侧列表 -->
    <div class="right-list">
      <div class="right-top">
        <div class="total">
          共<label>{{ allTotal }}</label
          >条记录
          <div class="search2 flex">
            <el-input v-model="searchword2" clearable placeholder="请输入文章检索词" @keyup.enter.native="toSearch2"></el-input>
            <el-button @click="toSearch2">检索</el-button>
          </div>
        </div>
        <div class="topictext" v-if="topicdetail">
          <span>Topic描述：</span><span :class="{ active: isshow }">{{ topicdetail }}</span>
          <a @click="showtopic" v-if="showtopictext">展开</a>
          <a @click="closetopic" v-if="!showtopictext">收起</a>
        </div>
      </div>
      <div class="right-item">
        <!-- 排序功能 -->
        <div class="sort-item">
          <p v-for="(item, index) in sortList" :class="{ checked: sortIndex == index }" :key="index" @click="handleChangeSort(index)">
            {{ item.label }}
          </p>
        </div>
        <subject-list-skeleton v-if="loadingAll || loading" variant="article" />
        <ul v-else>
          <li class="flex" v-for="(item, index) in list" :key="index">
            <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
            <div class="right-info">
              <p v-if="item.title" @click="toDetail(item)">
                <span v-safe-html="item.title"></span>
                <!-- <label :class="getColor(item.oaType)" v-safe-html="getoatext(item.oaType)"></label> -->
              </p>
              <p v-if="item.authorArray && item.authorArray.length > 0" class="author_p">
                作者：
                <span class="span-content" :class="{ green_span: element.click }" v-for="(element, index) in item.authorArray" :key="index">
                  <span class="span_a" @click="toAuthorDetail(element)" v-safe-html="element.authorName"></span>
                  <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
                  <div class="author-content">
                    <p class="mb10" v-safe-html="element.authorName"></p>
                    <p>
                      <span v-if="element.hindex != null"
                        >hindex：<label>{{ element.hindex }}</label></span
                      >
                      <span v-if="element.i10Index != null"
                        >i10Index：<label>{{ element.i10Index }}</label></span
                      >
                    </p>
                    <p>
                      <span v-if="element.citedByCount != null"
                        >citedByCount：<label>{{ element.citedByCount }}</label></span
                      >
                      <span v-if="element.worksCount != null"
                        >worksCount：<label>{{ element.worksCount }}</label></span
                      >
                    </p>
                    <p class="hui">{{ element.lastKnownInstitutionName }}</p>
                  </div>
                </span>
                <label v-if="item.showauthor && item.authorAllArray.length > 5" class="digestLabel" @click="showauthor(index)">展开</label>
                <label v-if="!item.showauthor" class="digestLabel" @click="closeauthor(index)">收起</label>
              </p>
              <p v-if="item.journalName">
                期刊信息：
                <span class="unline" @click="toHomeDetail(item)">{{ item.journalName }} ; </span>
                <label v-if="item.year">{{ item.year }} ; </label>
                {{ item.volume }}
                <label v-if="item.issue && item.issue != 'null'">({{ item.issue }})</label>
              </p>
              <p v-if="item.publishDate">出版时间：<span v-safe-html="item.publishDate"></span></p>
              <p v-if="item.doi">DOI：<span v-safe-html="item.doi"></span></p>
              <p v-if="item.hingeWord">
                关键词：<span class="fenhao" v-for="(element, idx) in item.hingeWordArray" :key="idx" @click="searchWords(element)">
                  <label class="green" v-safe-html="element"></label>
                  <label v-if="idx < item.hingeWordArray.length - 1">;</label>
                </span>
              </p>
              <!-- <p v-if="item.source">来源：{{ item.source }}</p> -->
              <div class="btn-p flex" @click.stop>
                <p class="num-tips">
                  引用量<span>{{ item.citedCount }}</span>
                </p>
                <div class="btn-right">
                  <div @click.stop class="flex">
                    <div class="btn" v-if="roles && item.gainLiteratureState === true && item.source !== '商业资源'" @click="getResource(item, index)" :class="{ noCourse: item.btnLoading }">
                      <img class="rotating-image" v-if="item.btnLoading" src="../../assets/images/loading_s.svg" />
                      <img class="img" src="../../assets/images/icon-qwhq-mr.png" />
                      <img class="hover-img" src="../../assets/images/icon-qwhq-xz-sub.png" />全文获取
                    </div>
                    <div class="achieve" v-if="Resourcelist == item.openAlexId" v-loading="achieveloading" ref="showPanel">
                      <div class="achieve-li">
                        <li v-for="(bookitem, index) in liblist" :key="index" class="1">
                          <a v-safe-html="bookitem.shortName" @click="libdetailUrl(item, bookitem)"></a>
                        </li>
                        <li v-if="gainResource.provideType == '3'" @click="recommendrecord(item)">
                          <a>推荐</a>
                        </li>
                        <li v-if="gainResource.provideType == '2'" @click="getResourceDetail(item, gainResource)">
                          <a>单篇采选</a>
                        </li>
                        <li v-if="gainResource.provideType == '1'" @click="getDeliverSave(item)">
                          <a>文献传递</a>
                        </li>
                        <li v-if="gainResource.provideType == '5'" @click="getLiterature(item)">
                          <a>请求获取</a>
                        </li>
                        <li v-if="paperData.baiduXueShuExist">
                          <a @click="goBaidu(paperData.baiduXueShuLink)">百度学术</a>
                        </li>
                        <li v-if="qingqiuhuoqu">
                          <a @click="getQingqiu(item)">请求获取</a>
                          <!-- <font><i class="el-icon-info"></i>我们在一天内进行处理，请您稍后重新打开界面获取。</font> -->
                        </li>
                      </div>
                    </div>
                  </div>
                  <div class="flex" @click="copylist(item.sid)">
                    <img src="../../assets/images/icon-fz-mr.png" class="img" />
                    <img src="../../assets/images/icon-fz-sub.png" class="hover-img" />复制
                  </div>
                  <!-- <div class="flex" @click="showReference(item)">
                      <img class="img" src="../../assets/images/icon-yy-mr.png" />
                      <img class="hover-img" src="../../assets/images/icon-yy-xz.png" />引用
                    </div> -->
                  <!-- <div class="flex" :class="{ checked: item.share }" @click="isCollect(item)">
                      <img class="img" :src="item.share ? collectTrue : collectFalse" />
                      <img class="hover-img" src="../../assets/images/icon-sc-xz.png" />收藏
                      <i class="share" v-if="item.shareCount > 0">{{ item.shareCount }}</i>
                    </div> -->
                </div>
              </div>
            </div>
          </li>
        </ul>
        <el-pagination v-if="!loadingAll && !loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="listTotal" hide-on-single-page> </el-pagination>

        <div class="noData" v-if="listTotal == 0 && !loadingAll && !loading">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
    <el-dialog title="绑定手机号" :visible.sync="phoneDialog" width="min(92vw, 520px)">
      <el-input placeholder="请输入手机号" v-model="phone" maxlength="20" @keyup.enter.native="submitAddphone($event)" class="phone-input"></el-input>
      <div class="flex phone">
        <el-input placeholder="验证码" v-model="code" />
        <span class="code" v-if="show" @click="getCode">发送验证码</span>
        <span class="code" v-else>{{ times }}</span>
      </div>
      <div class="flex phonebtn">
        <el-button @click="phoneDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddphone">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请求获取文献" :visible.sync="literatureDialogVisible" width="min(92vw, 420px)" :before-close="handleLiteratureClose">
      <div class="literature-dialog-content">
        <p class="literature-tip-sm">声明：请求的文献仅用于科研与教学使用，不做非法传播、复制</p>
        <p class="literature-tip">请正确输入邮箱，文献请求获取结果会以邮箱方式通知!</p>

        <el-form :model="literatureForm" :rules="literatureRules" ref="literatureFormRef">
          <el-form-item prop="email">
            <el-input v-model="literatureForm.email" placeholder="请输入邮箱地址" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer-right">
        <el-button @click="handleLiteratureClose">取 消</el-button>
        <el-button type="primary" @click="submitLiterature">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LeftMenu from "@/components/topic.vue";
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";
import { EventBus } from "../../utils/eventBus";
import baseurl from "../../api/baseurl";
export default {
  name: "topic",
  data() {
    return {
      loading: false,
      loadingAll: true,
      leftData: [],
      pageNo: 1,
      pageSize: 10,
      listTotal: 0,
      allTotal: 0,
      total: -1,
      list: [],
      defaultImg: require("../../assets/images/default.png"),
      searchWord: "",
      searchArray: [],
      searchword: "",
      searchword2: "",
      topicSid: "",
      showtopictext: true,
      isshow: true,
      roles: true,
      sourceList: [],
      Resourcelist: false,
      remmend: false,
      remmendlist: [],
      detaildoi: "",
      achieveloading: true,
      topicdetail: "",
      detailsid: "",
      onlyFlag: "",
      sortList: [
        {
          value: "publishDate",
          label: "出版时间",
        },
        {
          value: "_score",
          label: "相关度",
        },
        {
          value: "citedCount",
          label: "引用量",
        },
      ],
      sortVal: "publishDate",
      sortIndex: 0,
      showtop: false,
      liblist: [],
      Paperstate: "",
      gainResource: {},
      qingqiuhuoqu: false,

      subjectId: "",
      phoneDialog: false,
      show: true,
      phone: "",
      code: "",
      times: 60,

      currentResourceItem: null, // 存储当前资源项
      literatureDialogVisible: false,
      literatureItem: null,
      literatureForm: {
        email: "",
      },
      literatureRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
      },
      paperData: "",
    };
  },
  components: { LeftMenu, SubjectListSkeleton },

  mounted() {
    //点击空白关闭弹出
    document.addEventListener("click", this.bodyCloseMenus);
    this.timer = setInterval(() => {
      // 检查是否已通过EventBus加载数据
      if (sessionStorage.getItem("subjectNodes")) {
        let id = JSON.parse(sessionStorage.getItem("subjectNodes")).id;
        this.getSubjectId(id);
      }
    }, 300);

    EventBus.$on("submitSubject", this.getSubjectId);
  },
  beforeDestroy() {
    this.$notify.closeAll();
    // 组件销毁前移除事件监听，避免重复注册
    EventBus.$off("submitSubject");
  },
  methods: {
    getSubjectId(id) {
      window.clearInterval(this.timer);
      this.subjectId = id;
      this.loadingAll = true;
      this.loading = false;
      this.leftData = [];
      this.list = [];
      this.getList();
    },

    //初始化数据获取
    getList(subjectId = this.subjectId, hasTriedParent = false) {
      this.$http({
        url: "api/v1/subject/gateway/topic/sub/list?subjectId=" + subjectId,
        method: "GET",
      }).then(res => {
        const topicList = Array.isArray(res.data) ? res.data : [];
        if (topicList.length === 0 && !hasTriedParent) {
          const parentSubjectId = this.getCurrentSubjectParentId();
          if (parentSubjectId && parentSubjectId !== subjectId) {
            this.getList(parentSubjectId, true);
            return;
          }
        }

        this.loadingAll = false;
        this.leftData = topicList;
        this.applyTopicList(topicList);
      });
    },
    getCurrentSubjectParentId() {
      if (!sessionStorage.getItem("subjectNodes")) {
        return "";
      }
      try {
        const subjectNode = JSON.parse(sessionStorage.getItem("subjectNodes"));
        return subjectNode && subjectNode.parentId != null ? subjectNode.parentId : "";
      } catch (error) {
        return "";
      }
    },
    applyTopicList(topicList) {
      if (topicList.length > 0) {
        this.loading = true;

        this.topicSid = topicList[0].sid;
        this.topicdetail = topicList[0].description;
        this.onlyFlag = topicList[0].count;
        this.total = topicList[0].worksCount;
        // if (this.onlyFlag < 30) {
        //   this.$notify({
        //     title: "提示",
        //     message: "根据当前描述找到的主题相关度较低，可以尝试重新描述或对当前描述进行补充以提高检索精确度!",
        //     type: "warning",
        //     offset: 178,
        //   });
        // }
        // 根据话题  获取文章列表
        this.getsearchList();
      } else {
        this.listTotal = 0;
        this.allTotal = 0;
        this.topicdetail = "";
        this.list = [];
      }
    },
    //左侧筛选结果列表
    getsearchList() {
      this.loading = true;
      let postBody = {
        topicSid: this.topicSid,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderType: "DESC",
        searchWord: this.searchword2.trim(),
        orderField: this.sortVal,
      };
      this.$http({
        url: "api/v1/reception/journalpaper/topic/paper",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.list = res.data.recordList;
        this.allTotal = res.data.recordCount;
        this.listTotal = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;

        this.list.forEach((element, index) => {
          // 关键词
          if (element.hingeWord) {
            this.list[index].hingeWordArray = element.hingeWord.split(";");
          }

          if (element.author) {
            this.$set(this.list[index], "authorAllArray", element.authorList);
            this.$set(this.list[index], "authorArray", element.authorAllArray.slice(0, 5));
          }
          element.showauthor = true; //作者展开收起标识
          element.isshow = true;
        });
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getsearchList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getsearchList();
    },
    //文章二次检索
    toSearch2() {
      this.pageNo = 1;
      this.loading = true;
      this.list = [];
      this.twoSearchFlag = true;
      if (!this.searchword2.trim()) {
        this.twoSearchFlag = false;
      }
      this.getsearchList();
    },
    // 排序
    handleChangeSort(index) {
      this.sortIndex = index;
      this.sortVal = this.sortList[this.sortIndex].value;
      this.pageNo = 1;
      this.getsearchList();
    },
    //左侧筛选
    childByValue(val) {
      this.pageNo = 1;
      this.list = [];
      this.searchword2 = "";
      this.topicSid = val.topicSid;
      this.total = val.topictotal;
      this.topicdetail = val.description;
      this.loading = true;
      this.twoSearchFlag = false;
      this.getsearchList();
    },
    //跳转详情
    toDetail(item) {
      if (item.sid) {
        let _url = this.$router.resolve({
          path: "/articleDetail",
          query: { sid: item.sid },
        });
        window.open(_url.href, "_self");
      } else {
        if (item.detailUrl) {
          window.open(item.detailUrl);
        } else {
          let url = "https://doi.org/" + item.doi;
          window.open(url);
        }
      }
      // this.$router.push({ path: "homeDetail", query: { id: id } });
    },
    showtopic() {
      this.showtopictext = false;
      this.isshow = false;
    },
    closetopic() {
      this.showtopictext = true;
      this.isshow = true;
    },
    showDigest(index) {
      this.list[index].showauthor = false;
      this.list[index].isshow = false;
      this.$forceUpdate();
    },
    closeDigest(index) {
      this.list[index].showauthor = true;
      this.list[index].isshow = true;
      this.$forceUpdate();
    },
    // 期刊信息跳转
    toHomeDetail(item) {
      let _url = this.$router.resolve({
        path: "/homeDetail",
        query: { sid: item.journalSid },
      });
      window.open(_url.href, "_self");
    },
    // 关键词检索
    searchWords(item) {
      let val = item.split("<span style='color:red'>").join("").split("</span>").join("");
      sessionStorage.setItem(
        "search-keyword",
        JSON.stringify({
          word: val,
          paper: "hingeWord",
          searchType: 1,
        }),
      );
      let _url = this.$router.resolve({
        path: "/article",
      });
      window.open(_url.href, "_self");
    },
    //推荐
    recommendrecord(item) {
      this.Resourcelist = false;
      this.$http({
        url: "api/v1/advice/record/save/sys?openAlexId=" + item.openAlexId,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("推荐成功");
        } else {
          this.$message.error("推荐失败");
        }
      });
    },
    //跳转外部扩展链接
    literatureUrl(item) {
      if (item.indexOf("apply/paper/resource") > 0) {
        this.getResourceDetail(item);
      } else {
        this.Resourcelist = false;
        window.open(item);
      }
    },
    //获取全文
    getResource(item, index) {
      // 1, “馆藏”
      // 2, “OA”
      // 3, “非馆藏非OA”
      // 5, “采购”
      // 10, “未登录”
      // if (item.source == "馆外资源") {
      //   this.Resourcelist = false;
      //   this.$message.error("馆外无法获取资源");
      //   this.achieveloading = false;
      //   return;
      // }
      if (this.list[index].btnLoading) {
        return;
      }
      this.list[index].btnLoading = true;
      this.$forceUpdate();

      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      let postBody = {
        doi: this.detaildoi,
        openAlexId: item.openAlexId,
      };
      this.$http({
        url: "api/v1/wantbuyR/queryPaper",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.data) {
          this.list[index].btnLoading = false;
          this.$forceUpdate();
          this.paperData = res.data;
          this.qingqiuhuoqu = false;
          this.Resourcelist = false;
          this.gainResource = {};
          this.liblist = [];
          if (res.data.state == 1) {
            this.Resourcelist = res.data.openAlexId;
            this.liblist = res.data.ebookNameList;
            this.achieveloading = false;
          } else if (res.data.state == 2) {
            // 显示请求获取按钮
            this.Resourcelist = res.data.openAlexId;
            this.qingqiuhuoqu = true;
            this.achieveloading = false;
          } else if (res.data.state == 3) {
            this.Resourcelist = res.data.openAlexId;
            this.gainResource = res.data.gainResourceBo;
            if (res.data.gainResourceBo.provideType === 4) {
              this.Resourcelist = false;
              this.$message.error("馆外无法获取资源");
              this.achieveloading = false;
              return;
            }
            this.achieveloading = false;
          } else if (res.data.state == 63) {
            window.open(
              `http://lib.cqu.edu.cn/articlesearch/web_searchingResult?key={"rule":{"ruleBody":"DI=[@DI_79107149_0_f]","ruleParameters":[{"key":"@DI_79107149_0_f","value":"${this.detaildoi}"}]},"filterRule":{"ruleBody":"TY=[@TY_96453382_0_f]","ruleParameters":[{"key":"@TY_96453382_0_f","value":"3"}]}}&keyword=${this.detaildoi}`,
            );
          } else if (res.data.state == 5 || res.data.state == 6 || res.data.state == 7) {
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.applyPaperSourceSid}&type=${res.data.state}`,
              method: "get",
            }).then(downres => {
              if (downres.code == 200) {
                // 采购下载
                if (res.data.state == 5) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/purchase/download?uid=" + downres.data);
                }
                // 文献传递下载
                if (res.data.state == 6) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/deliver/download?uid=" + downres.data);
                }
                // 个人上传文件下载
                if (res.data.state == 7) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/person/download?uid=" + downres.data + "&openAlexId=" + res.data.openAlexId);
                }
              }
            });
          } else if (res.data.state == 10) {
            // this.$router.push({ path: "/lg", query: { word: true } });
            this.$message.warning("该资源的全文仅限用户登录后获取，请先登录");
            //  window.open(`/lg?word=true&isback=true`, "_self");
          } else if (res.data.state == 20) {
            //oa附件  下载附件
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.openAlexId}&type=${res.data.state}`,
              method: "get",
            }).then(res => {
              if (res.code == 200) {
                window.open(baseurl.baseUrl + "api/v1/wantbuyR/oa/download?uid=" + res.data);
              }
            });
          } else if (res.data.state == 52) {
            let title = "";
            let doi = "";
            if (res.data.doi) {
              doi = res.data.doi;
            } else {
              //个别数据会有\n 去除\n
              if (res.data.title.includes("\n")) {
                title = res.data.title.split("\n").join("");
              } else {
                title = res.data.title;
              }
              doi = title;
            }
            let str = '{"query":{"query_string":{"query":"' + doi + '","default_operator":"AND"}},"track_total_hits":true}';
            let query = encodeURIComponent(str);
            window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
          }
        }
      });
    },
    // 馆藏资源跳转
    libdetailUrl(item, bookItem) {
      this.Resourcelist = false;
      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      if (bookItem.shortName == "DOAJ-Directory of Open Access Journals") {
        if (!this.detaildoi) {
          this.detaildoi = item.title;
        }
        let str = '{"query":{"query_string":{"query":"' + this.detaildoi + '","default_operator":"AND"}},"track_total_hits":true}';
        let query = encodeURIComponent(str);
        window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
        return;
      } else {
        this.$http({
          url: "api/v1/wantbuyR/ebook/link?ebookSid=" + bookItem.sid + "&doi=" + this.detaildoi + "&openAlexId=" + item.openAlexId,
          method: "GET",
        }).then(res => {
          if (res.code == 200) {
            window.open(res.data);
          }
        });
      }
    },
    gethttp(val) {
      if (val.indexOf("http") == 0) {
        return true;
      }
    },
    scrollToTop() {
      this.$nextTick(() => {
        const node = document.getElementById("topic_top");
        setTimeout(() => {
          if (node) {
            this.$nextTick(() => {
              node.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start",
              });
            });
          }
        }, 100);
      });
    },
    // 文献传递
    getDeliverSave(item, bitem) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/deliver/apply/sys/save?openAlexId=" + item.openAlexId,
        method: "get",
      }).then(res => {
        window.open(`/asp/myDeliver`, "_self");
        // this.$message.success("文献传递成功，请到个人中心我的文献传递中查看~");
      });
    },
    // 文献请求获取 弹出一个弹框输入邮箱
    getLiterature(item) {
      this.Resourcelist = false;
      this.literatureItem = item;
      this.literatureForm.email = "";
      this.literatureDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.literatureFormRef) {
          this.$refs.literatureFormRef.clearValidate();
        }
      });
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.code == 200 && res.data && res.data.email) {
          this.literatureForm.email = res.data.email;
        }
      });
    },
    handleLiteratureClose() {
      this.$refs.literatureFormRef.resetFields();
      this.literatureDialogVisible = false;
    },
    submitLiterature() {
      this.$refs.literatureFormRef.validate(valid => {
        if (!valid) return;
        this.literatureDialogVisible = false;
        this.Resourcelist = false;
        this.$http({
          url: "/api/v1/literature-gain-apply/save",
          method: "POST",
          data: {
            paperSid: this.literatureItem.sid,
            email: this.literatureForm.email,
          },
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("请求获取成功，文献获取通知将发送到您的邮箱");
          }
        });
      });
    },
    // 百度学术
    goBaidu(url) {
      window.open(url);
    },
    // 请求获取
    getQingqiu(item) {
      this.Resourcelist = false;
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/literature-gain-apply/save",
        method: "post",
        data: {
          paperSid: item.sid,
        },
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("请求成功，我们将在一天内进行处理，请您稍后在文献服务平台 - 我的申请 - 我的文献申请中获取!");
          this.qingqiuhuoqu = false;
        }
      });
    },
    getResourceDetail(item) {
      this.Resourcelist = false;
      this.currentResourceItem = item;
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (!res.data.phone) {
          this.code = "";
          this.phone = "";
          clearInterval(this.timer);
          this.show = true;
          this.phoneDialog = true;
          return;
        }
        if (item.doi) {
          this.detaildoi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        } else {
          this.detaildoi = "";
        }
        let postBody = {
          doi: this.detaildoi,
          openAlexId: item.openAlexId,
        };
        this.$http({
          url: "/api/v1/promote/wantbuy/getResource",
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.data.state == 2) {
            this.$message.success("您已提交过申请");
            return;
          }
          if (res.data.state == 3) {
            this.$message.success("订单是否有对应DOI,订购中");
            return;
          }
          if (res.data.state == 4) {
            this.$message.success("供应商暂不提供该资源");
            return;
          }
          if (res.data.state == 5) {
            this.$message.success("符合采选规则,获取成功");
            return;
          }
          // 不符合采选规则,待申请
          if (res.data.state == 6) {
            // 申请
            let dataBody = {
              doi: res.data.doi,
              title: res.data.title,
              paperPrice: res.data.paperPrice,
              singlePrice: res.data.singlePrice,
              totalPrice: res.data.totalPrice,
              badWord: res.data.badWord,
              supplierId: res.data.supplierId,
            };
            this.$http({
              url: "/api/v1/promote/wantbuy/apply",
              method: "POST",
              data: dataBody,
            }).then(respones => {
              this.$message.success(respones.data);
            });

            return;
          }
          if (res.data.state == 8) {
            //已提交过申请
            this.$message.success("资源被图书馆收录");
            return;
          }
          if (res.data.state == 21) {
            //系统繁忙
            this.$message.error("系统繁忙，请稍后重试");

            return;
          }
          if (res.data.state == 22) {
            //资源申请成功
            this.$message.success("资源申请成功，请在个人申请列表中查看");
            return;
          }
        });
      });
    },
    bodyCloseMenus(e) {
      if (this.Resourcelist) {
        this.Resourcelist = false;
      }
    },
    //作者展开收起
    showauthor(index) {
      this.list[index].showauthor = false;
      this.list[index].authorArray = this.list[index].authorAllArray;
      this.$forceUpdate();
    },
    closeauthor(index) {
      this.list[index].showauthor = true;
      this.list[index].authorArray = [];
      for (let i = 0; i < 5; i++) {
        this.list[index].authorArray.push(this.list[index].authorList[i]);
      }
      this.$forceUpdate();
    },
    // 作者详情跳转
    toAuthorDetail(item) {
      if (item.click) {
        let _url = this.$router.resolve({
          path: "/authorDetail",
          query: { authorSid: item.sid },
        });
        window.open(_url.href, "_self");
      }
      // this.$http({
      //   url: `api/v1/reception/author/checkAuthorJumpDetail?authorSid=${authorSid}`,
      //   method: "get",
      // }).then(res => {
      //   setTimeout(() => {
      //     if (res.code == 200) {
      //       if (res.data) {
      //         let _url = this.$router.resolve({
      //           path: "/authorDetail",
      //           query: { authorSid: authorSid },
      //         });
      //         window.open(_url.href, "_blank");
      //       } else {
      //         this.$message.error("该作者暂无收录");
      //       }
      //     }
      //   }, 500);
      // });
    },
    //oa状态
    getColor(item) {
      return oaColor(item);
    },
    getoatext(item) {
      return oaText(item);
    },
    //复制引文
    copylist(id) {
      // 根据当前引文格式获取选中内容
      this.$http({
        url: "api/v1/wantbuyR/copy/context?sid=" + id,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          let copydata = res.data;
          try {
            navigator.clipboard.writeText(copydata).then(() => {
              this.$message.success("已复制,您可随意粘贴使用");
            });
          } catch (err) {
            // 兼容旧浏览器的复制方式
            const textarea = document.createElement("textarea");
            textarea.value = copydata;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.$message.success("已复制,您可随意粘贴使用");
          }
        }
      });
    },
    getCode() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      this.$http({
        url: `api/v1/tourist/check/repeat/mobile?mobile=${this.phone}`,
        method: "get",
      }).then(res => {
        if (res.data) {
          this.times = 60;
          let formData = new FormData();
          formData.append("mobilePhone", this.phone);

          this.$http({
            url: `api/v1/user/sendCode`,
            method: "POST",
            data: formData,
          }).then(res => {
            this.show = false;
            this.timer = setInterval(() => {
              this.times--;
              if (this.times === 0) {
                this.show = true;
                clearInterval(this.timer);
              }
            }, 1000);
          });
        } else {
          this.$message.error("该手机号已存在");
          return;
        }
      });
    },
    submitAddphone() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.code.trim()) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phone);
      formData.append("smsCode", this.code);
      this.$http({
        url: `api/v1/user/changephone`,
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.phoneDialog = false;
          // 绑定成功后自动再次调用getResourceDetail方法
          if (this.currentResourceItem) {
            this.getResourceDetail(this.currentResourceItem);
          }
        }
      });
    },
    // 在组件销毁前清除定时器
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-container {
  width: calc(100% - 40px);
  max-width: 1300px;
  min-width: 0;
  margin: 20px auto;
  border-radius: 5px;
  padding-bottom: 0;
  display: flex;
  box-sizing: border-box;
  .right-list {
    flex: 1;
    min-width: 0;
    margin-bottom: 20px;
    .right-top {
      background: #fff;
    }
    .filter {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #eeeeee;
      line-height: 30px;
      .searchword {
        margin-right: 20px;
        label {
          color: #63ace5;
        }
      }
      .flex {
        display: inline-block;
        border: 1px solid #cccccc;
        color: #63ace5;
        font-size: 14px;
        padding: 2px 5px;
        margin-right: 10px;
        i {
          margin-left: 5px;
          font-size: 12px;
          color: #999999;
          cursor: pointer;
        }
      }
    }
    .total {
      padding: 15px;
      color: #666666;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      label {
        color: #e40000;
        margin: 0 3px;
      }
      p {
        margin-left: 30px;
        ::v-deep .el-input__inner {
          width: 140px;
          border: none;
          background: #f7f7f7;
        }
      }
      .search2 {
        margin-left: auto;
        align-items: center;
        background: #fff;
        width: min(371px, 100%);
        border: 1px solid #ccc;
        ::v-deep .el-input {
          flex: 1;
          width: auto;
          min-width: 0;
        }
        ::v-deep .el-input__inner {
          border-radius: 0;
          width: 100%;
          border: 0px;
        }
        .el-button {
          background-color: #63ace5;
          border-color: #63ace5;
          color: #ffffff;
          height: 40px;
          line-height: 6px;
          border-radius: 0px;
        }
      }
      img {
        width: 22px;
        height: 24px;
        cursor: pointer;
        margin-right: 20px;
      }
    }
    .topictext {
      font-size: 15px;
      color: #666666;
      padding: 15px;
      a {
        color: #63ace5;
        cursor: pointer;
        padding-left: 8px;
      }
    }
    .active {
      display: inline-block;
      white-space: nowrap;
      width: 85%;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: bottom;
    }
    .right-item {
      background: #fff;
      margin-top: 10px;
      padding: 0 20px;
      min-height: 350px;
      ul {
        li {
          padding: 20px 0;
          border-bottom: 1px dashed #eeeeee;
          .index {
            width: 50px;
            line-height: 30px;
          }
          .unline {
            cursor: pointer;
            color: #63ace5;
          }
          .unline:hover {
            text-decoration: underline;
          }

          .right-info {
            color: #666666;
            flex: 1;
            min-width: 0;
            position: relative;
            > p {
              line-height: 30px;
              font-size: 14px;
              &:nth-of-type(1) {
                color: #333;
                font-size: 16px;
                font-weight: 400;
                margin-bottom: 10px;
                cursor: pointer;
                label {
                  font-size: 14px;
                  padding-left: 5px;
                  width: 60px;
                  line-height: 22px;
                  text-align: center;
                  color: white;
                  font-weight: initial;
                  padding: 2px 5px;
                  margin-left: 5px;
                }
              }
              img {
                margin-left: 10px;
                height: 22px;
                vertical-align: -6px;
              }
            }
            .yinzi {
              position: absolute;
              bottom: 0;
              left: 0;
              font-size: 14px;
              span {
                color: #45c1c3;
              }
            }
            .fenhao {
              .green {
                color: #63ace5;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              label {
                &:last-of-type {
                  margin: 0 5px;
                }
              }
            }
          }
          &:hover {
            .right-info {
              > p {
                &:nth-of-type(1) {
                  span {
                    background-image: linear-gradient(to right, #006eb3, #63ace5);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  }
                }
              }
            }
          }
        }
      }
      .achieve {
        background: #ffffff;
        border-radius: 2px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 35px;
        right: 0;
        z-index: 99999;
        cursor: text;
        &::after {
          content: "";
          position: absolute;
          top: -6px;
          right: 10px;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-bottom: 10px solid #fff; /* 三角形的颜色 */
        }
        .achieve-li {
          min-width: 270px;
          max-width: min(700px, calc(100vw - 48px));
          overflow-y: auto;
          max-height: 200px;
          padding: 15px 20px;
        }

        li {
          font-size: 16px;
          line-height: 28px;
          padding: 0px;
          border-bottom: 0px;
          a {
            text-decoration: underline;
            color: #63ace5;
            cursor: pointer;
          }
          font {
            color: #b3b3b3;
            font-size: 12px;
            display: block;
            line-height: 20px;
            i {
              margin-right: 5px;
              color: #e6a23c;
            }
          }
          span {
            font-size: 14px;
            color: #b3b3b3;
            margin-left: 5px;
          }
          .el-icon-warning {
            color: #e6a23c;
            padding: 0px 10px;
            width: 30px;
          }
        }
      }
      ::-webkit-scrollbar {
        display: block;
        width: 3px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #63ace5;
      }

      /* 定制滚动条按钮样式 */
      ::-webkit-scrollbar-button {
        background-color: #c1c1c1;
      }
    }
    .btn-p {
      align-items: end;
      margin-top: 25px;
      font-size: 14px;
      .num-tips {
        span {
          // color: #63ace5;
          margin-left: 5px;
        }
      }
      .share {
        font-style: normal;
        color: #63ace5;
        margin-left: 5px;
      }
    }
    .btn-right {
      margin-left: auto;
      display: flex;
      align-items: center;
      font-size: 14px;
      .rotating-image {
        animation: rotate 1s linear infinite;
      }
      @keyframes rotate {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
      img {
        margin-top: 2px;
        margin-right: 5px;
      }
      .checked {
        color: #63ace5;
      }
      .noCourse {
        cursor: default !important;
      }
      .flex {
        align-items: center;
        margin-left: 30px;
        cursor: pointer;
        position: relative;
        &:hover {
          color: #63ace5;
          text-decoration: underline;
          .hover-img {
            display: inline-block;
          }
          .img {
            display: none;
          }
        }
        .btn {
          display: flex;
          align-items: center;
        }

        .hover-img {
          display: none;
        }
      }
    }
    .span-content {
      position: relative;
      .author-content {
        top: 30px;
        left: 0px;
      }
    }
    .green_span {
      cursor: pointer;
      &:hover {
        .span_a {
          text-decoration: underline;
        }
        transition: all 1s;
        .author-content {
          display: inline-block;
        }
      }
      .span_a {
        color: #63ace5;
      }
    }
    .author-content {
      position: absolute;
      background: #fff;
      box-shadow: 0 0 5px #d3d3d3;
      display: none;
      padding: 10px;
      z-index: 9999;
      top: -30px;
      right: -210px;
      min-width: 300px;
      max-width: min(420px, calc(100vw - 48px));
      .mb10 {
        font-size: 16px;
        margin-bottom: 10px !important;
      }
      .hui {
        margin-top: 5px !important;
        white-space: pre-wrap;
      }
      p {
        font-size: 14px;
        margin: 0 !important;
        line-height: 20px;
        span {
          position: relative;
          &:first-of-type {
            margin-right: 14px;
            &::before {
              content: "";
              position: absolute;
              width: 1px;
              height: 14px;
              background: #ccc;
              right: -7px;
              top: 50%;
              margin-top: -7px;
            }
          }
          label {
            color: #63ace5;
          }
        }
      }
    }
  }
  .scrollTop {
    position: fixed;
    bottom: 90px;
    right: 30px;
    z-index: 999;
    cursor: pointer;
  }
  .digestLabel {
    cursor: pointer;
    margin-left: 10px;
    &:hover {
      color: #63ace5;
    }
  }
  /* 排序样式 */
  .sort-item {
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 20px 20px 13px 20px;
    p {
      margin-right: 30px;
      font-size: 16px;
      font-weight: bold;
      display: inline-block;
      cursor: pointer;
      position: relative;
      color: #86909c;
      &:hover {
        color: #333;
        &::before {
          content: "";
          position: absolute;
          bottom: -14px;
          left: 50%;
          margin-left: -25px;
          height: 2px;
          width: 50px;
          z-index: 88;
          background: #2c5f97;
        }
      }
    }
    .checked {
      color: #333;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        bottom: -14px;
        left: 50%;
        margin-left: -25px;
        height: 2px;
        width: 50px;
        z-index: 88;
        background: #2c5f97;
      }
    }
  }
}

@media (max-width: 1024px) {
  .table-container {
    flex-direction: column;

    .left {
      flex: 0 0 auto;
      width: 100%;
    }

    .right-list .total {
      flex-wrap: wrap;
      gap: 12px;

      .search2 {
        flex: 1 1 320px;
      }
    }
  }
}

@media (max-width: 768px) {
  .table-container {
    width: calc(100% - 24px);
    margin: 12px auto;

    .right-list {
      .total,
      .topictext {
        padding: 12px;
      }

      .total .search2 {
        flex-basis: 100%;
        width: 100%;
        margin-left: 0;
      }

      .active {
        width: calc(100% - 60px);
      }

      .right-item {
        padding: 0 12px;

        > ul > li {
          align-items: flex-start;

          .index {
            width: 28px;
            flex-shrink: 0;
          }

          .right-info {
            overflow-wrap: anywhere;
          }
        }

        .achieve {
          right: auto;
          left: 0;

          .achieve-li {
            min-width: min(270px, calc(100vw - 48px));
            padding: 12px;
          }
        }
      }

      .btn-p {
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
      }

      .btn-right {
        width: 100%;
        margin-left: 0;
        flex-wrap: wrap;
        gap: 12px;

        .flex {
          margin-left: 0;
        }
      }

      .author-content {
        right: auto;
        left: 0;
        min-width: min(300px, calc(100vw - 48px));
      }
    }

    ::v-deep .el-pagination {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      row-gap: 8px;
      padding: 16px 0;
      white-space: normal;
    }
  }
}

::v-deep .el-pager li.active,
::v-deep .el-pager li:hover,
::v-deep .el-select .el-input.is-focus .el-input__inner,
::v-deep .el-pagination__sizes .el-input .el-input__inner:hover {
  color: #63ace5;
  border-color: #63ace5;
}
::v-deep .el-pager li:hover {
  color: #63ace5;
}
::v-deep .el-pagination button:hover {
  color: #63ace5;
}
::v-deep .el-pagination__jump .el-input__inner:focus {
  border-color: #63ace5;
}
::v-deep .el-dialog__body {
  padding: 20px 20px 50px 20px;
}
.phone {
  margin: 20px 0px;
  ::v-deep .el-input {
    .el-input__inner {
      padding-right: 120px;
    }
  }
  align-items: center;
  position: relative;
  .code {
    position: absolute;
    right: 15px;
    padding: 0 20px;
    color: #15babc;
    top: 0;
    line-height: 38px;
    cursor: pointer;
    &::after {
      position: absolute;
      left: 0;
      width: 1px;
      height: 20px;
      background: #c9ebf7;
      content: "";
      top: 10px;
    }
  }
}
.phonebtn {
  display: flex;
  justify-content: flex-end;
}
.literature-dialog-content {
  .literature-tip {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.6;
  }
  .literature-tip-sm {
    font-size: 12px;
    margin-bottom: 20px;
    color: #ff0000;
  }
}
::v-deep .el-dialog__footer .dialog-footer-right {
  text-align: right;
  display: block;
}
</style>
